import posthog from 'posthog-js';

const projectToken = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;
const apiHost = import.meta.env.VITE_POSTHOG_HOST;
let initialized = false;

function reportMissingConfiguration(): void {
    if (!import.meta.env.DEV) return;
    if (!projectToken) {
        console.error(
            'VITE_POSTHOG_PROJECT_TOKEN variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_PROJECT_TOKEN is configured',
        );
    }
    if (!apiHost) {
        console.error(
            'VITE_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_HOST is configured',
        );
    }
}

export function initializePostHog(): boolean {
    if (initialized) return true;
    if (!projectToken || !apiHost) {
        reportMissingConfiguration();
        return false;
    }

    posthog.init(projectToken, {
        api_host: apiHost,
        defaults: '2026-05-30',
        person_profiles: 'identified_only',
        capture_pageview: 'history_change',
        capture_pageleave: true,
        logs: {
            serviceName: 'lopaka-web',
            environment: import.meta.env.MODE,
        },
    });
    initialized = true;
    return true;
}

export function capturePostHogEvent(eventName: string, properties?: Record<string, unknown>): void {
    if (initialized) posthog.capture(eventName, properties);
}

export function capturePostHogException(error: unknown, properties?: Record<string, unknown>): void {
    if (initialized) posthog.captureException(error, properties);
}

export function logPostHogInfo(message: string, attributes?: Record<string, string | number | boolean>): void {
    if (initialized) posthog.logger.info(message, attributes);
}

export function identifyPostHogUser(distinctId: string): void {
    if (initialized) posthog.identify(distinctId);
}
